<template>
    <div id="create-campaign">
        <div class="app-container" v-show="!$global.loading">

            <v-container>
                <div class="d-flex justify-content-between">
                    <div class="page-title mb-3">
                        Création d'une Campagne d'adhésion
                    </div>

                    <div>
                        <v-tooltip slot="append-outer" bottom v-if="account.cadh_configurations.length === 0">
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" color="warning">warning</v-icon>
                            </template>
                            <span>Aucun formulaire d'adhésion n'est configuré sur votre compte.</span>
                        </v-tooltip>
                    </div>
                </div>


                <v-text-field v-model="campaign.name" background-color="white" label="Nom de votre campagne" outlined>
                </v-text-field>

                <v-stepper @change="setCurrentStep" :value="currentStep" non-linear>
                    <v-stepper-header>
                        <v-stepper-step editable step="1">
                            Prestataires ({{ emailsValid.length }})
                        </v-stepper-step>

                        <v-stepper-step editable step="2">
                            Formulaire
                        </v-stepper-step>

                        <v-stepper-step editable step="3">
                            Contenu de l'e-mail
                        </v-stepper-step>

                        <v-stepper-step editable step="4">
                            Options
                        </v-stepper-step>

                        <v-stepper-step editable step="5">
                            Finaliser
                        </v-stepper-step>
                    </v-stepper-header>

                    <v-stepper-items>
                        <v-stepper-content step="1">
                            <verification v-if="providers.length" :is-revival="false">
                            </verification>
                        </v-stepper-content>

                        <v-stepper-content step="2">
                            <configuration-choice></configuration-choice>
                        </v-stepper-content>

                        <v-stepper-content step="3">
                            <email v-if="providers.length"></email>
                        </v-stepper-content>

                        <v-stepper-content step="4">
                            <options :update-mode="false" :criterias="criterias" :is-revival="false">
                            </options>
                        </v-stepper-content>

                        <v-stepper-content step="5">
                            <finalize :cadh-name="campaign.name" :update-mode="false" :is-revival="false">
                            </finalize>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-container>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import * as EmailValidator from "email-validator"
import Verification from "@/components/campaign/cadh/stepers/Verification"
import Email from "@/components/campaign/cadh/stepers/Email"
import Finalize from "@/components/campaign/cadh/stepers/Finalize"
import Options from "@/components/campaign/cadh/stepers/Options"
import ConfigurationChoice from "./stepers/ConfigurationChoice.vue"

export default {
    name: "CreateCampaign",
    components: { ConfigurationChoice, Finalize, Email, Verification, Options },
    data() {
        return {
            campaign: { name: null },
            contacts: [],
            sender: null,
            receiver: null,
        }
    },
    methods: {
        ...mapMutations("createCadh", [
            "setSender", "setFirstPartMail", "setLastPartMail", "setProviders", "setEmailsValid",
            "setEmailsWrong", "setCurrentStep", "resetState",
        ]),
        getProviders() {
            let providerIds = localStorage.getItem("providerIds")

            let payload = {
                providerIds: JSON.parse(providerIds),
            }

            this.$http.post("auth/providers/ids", payload).then(res => {
                this.setProviders(res.body.data.providers)
                this.setEmailLists()
            })
        },
        initDefaultName() {
            let year = this.$moment().format("YYYY")

            this.campaign.name = "Campagne d'adhésion " + year
        },
        setEmailLists() {
            let emailsValid = []
            let emailsWrong = []

            this.providers.forEach(provider => {
                if (provider.contact === null) {
                    provider.error = "Email non renseigné"
                    emailsWrong.push(provider)
                } else if (!EmailValidator.validate(provider.email)) {
                    provider.error = "Mauvais format d'email"
                    emailsWrong.push(provider)
                } else {
                    emailsValid.push(provider)
                }
            })

            this.setEmailsValid(emailsValid)
            this.setEmailsWrong(emailsWrong)
        },
    },
    async created() {
        this.$global.loading = true

        this.resetState()

        const promise1 = this.$store.dispatch("account/loadSenders").then(() => {
            if (this.senders.length) {
                this.setSender(this.senders[0])
            }
        })

        this.initDefaultName()

        const promise2 = this.getProviders()

        const promise3 = this.$http.get("auth/account/contacts").then(res => {
            this.contacts = res.body.data.contacts
        })

        Promise.all([promise1, promise2, promise3]).then(() => {
            setTimeout(() => {
                this.$global.loading = false
            }, 100)
        })

        this.$store.dispatch("account/fetchContacts")
        this.$store.dispatch("resource/fetchCategories")

        this.$global.$on("change-step", (step) => {
            this.currentStep = step
        })
    },
    computed: {
        ...mapState("account", ["senders", "account"]),
        ...mapState("createCadh", ["emailsValid", "emailsWrong", "providers", "currentStep"]),
    },
    destroyed() {
        this.$global.$off("change-step")
    },
}
</script>>